module.exports = __webpack_public_path__ + "static/media/8OLA7.d7778e34.jpg";